import React from 'react';

import { PatientActivity } from '@uplift/api';
import { DateObject } from '@uplift/services';
import { ActivityFeedGroup } from '../../../../components/ActivityFeed';

import { ActivityItem } from './ActivityItem.component';

export type ActivityListProps = {
  patientId: string;
};


export const ActivityPage: React.VFC<{
  now: DateObject;
  activities: PatientActivity[];
  prevActivities: PatientActivity[];
  onItemSelect: (el?: PatientActivity) => void;
}> = React.memo(({ prevActivities, now, activities, onItemSelect }) => {
  return (
    <ActivityFeedGroup
      now={now}
      items={activities}
      prevItems={prevActivities}
      getDate={activity => activity.datetime}
      getKey={activity => activity.datetime}
      renderItem={activity => (
        <ActivityItem
          onActivityClick={() => onItemSelect(activity)}
          onDocumentClick={() => onItemSelect(activity)}
          activity={activity}
        />
      )}
    />
  );
});
